/**
 * Engine selector — mirrors the ?debug persistence pattern:
 *   - `?engine=orb|global|sp_fallback` in the URL writes to localStorage
 *     and persists across navigation/reload
 *   - `?engine=` (empty) or `?engine=clear` removes the override
 *   - With no override, the engine's own default (`global` per its memo)
 *     is used — server proxy doesn't append the param at all
 *
 * Evaluated once at module load. Visit `?engine=orb` to stick on ORB
 * until you visit `?engine=clear`.
 */
const STORAGE_KEY = "focusEngine";

const urlEngine = new URLSearchParams(window.location.search).get("engine");
if (urlEngine === "" || urlEngine === "clear") {
  localStorage.removeItem(STORAGE_KEY);
} else if (urlEngine) {
  localStorage.setItem(STORAGE_KEY, urlEngine);
}

export const ENGINE_OVERRIDE: string =
  localStorage.getItem(STORAGE_KEY) || "";
